export default "__VITE_ASSET__Dy5sxKrl__"